var map = {
	"./de.json": 4871,
	"./en-GB.json": 9811,
	"./en.json": 4319,
	"./en_GB.json": 6673,
	"./es.json": 1160,
	"./fr.json": 8796,
	"./it.json": 7874,
	"./pl.json": 1976,
	"./pt.json": 8928,
	"./sv.json": 7989,
	"./uk.json": 2096,
	"src/viewLayer/assets/locales/de.json": 4871,
	"src/viewLayer/assets/locales/en-GB.json": 9811,
	"src/viewLayer/assets/locales/en.json": 4319,
	"src/viewLayer/assets/locales/en_GB.json": 6673,
	"src/viewLayer/assets/locales/es.json": 1160,
	"src/viewLayer/assets/locales/fr.json": 8796,
	"src/viewLayer/assets/locales/it.json": 7874,
	"src/viewLayer/assets/locales/pl.json": 1976,
	"src/viewLayer/assets/locales/pt.json": 8928,
	"src/viewLayer/assets/locales/sv.json": 7989,
	"src/viewLayer/assets/locales/uk.json": 2096
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6157;